import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import he from "./languages/he";
import en from "./languages/en";
import ar from "./languages/ar";
import ru from "./languages/ru";

i18n.use(initReactI18next).init({
  resources: {
    he: {
      translation: { ...he },
    },
    en: {
      translation: { ...en },
    },
    ar: {
      translation: { ...ar },
    },
    ru: {
      translation: { ...ru },
    },
  },
  fallbackLng: "he",
});
export default i18n;
